import { BrowserRouter } from 'react-router-dom'
import "@fontsource/ubuntu"
import Router from './Component/Router/Router'

const App = () => {
  return (
    <BrowserRouter>
      <Router />
    </BrowserRouter>
  )
}

export default App